// Local Deps
import { makeGraphQLRequest } from '../../../utils/requestUtils';

export async function querySupplierCapsForautoComplete(criteria) {
  // Format query
  const query = `query SupplierSearch($criteria: SupplierSearchInput ) { 
    supplierSearch(supplierCriteria: $criteria )
    { 
      suppliers{
        
          cage,
          company,
          email
        
      }
    } 
  }`;
  // Variables
  const variables = { criteria: { ...criteria } };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.supplierSearch.suppliers;
}

export async function emailSuppliers(data) {
  const query = `mutation emailSuppliers( $criteria: EmailSupplierInput ) { emailSuppliers (EmailSupplierInput: $criteria) { message} }`;
  const variables = { criteria: { ...data } };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.emailSuppliers;
}



// WEBPACK FOOTER //
// ./src/components/Modals/sendSolicitations/graphql.js